import { OrgTypes } from '@symon-ai/wisepipe-common';
import { OrgPlan } from '@symon-ai/wisepipe-user';
import { orgFeatureFlagSchema } from './orgFeatureFlag';
export const orgInfoSchema = {
    $id: 'urn:wisepipe-domain-authorize:OrgInfo',
    type: 'object',
    properties: {
        id: { type: 'string', format: 'uuid' },
        name: { type: 'string', minLength: 1, maxLength: 100 },
        orgPlan: {
            type: 'string',
            enum: Object.values(OrgPlan)
        },
        initialCredit: { type: 'number', minimum: 0 },
        seats: { type: 'number', minimum: 0 },
        createdAt: { type: 'string', format: 'date-time' },
        supportedLoginTypes: { type: 'array', items: { type: 'string' } },
        featureFlags: { type: 'array', items: { $ref: orgFeatureFlagSchema.$id } },
        salesforceAcctId: { type: 'string' },
        orgType: { type: 'string', enum: Object.values(OrgTypes) },
        orgTimezone: { type: 'string', minLength: 1 }
    },
    required: ['id', 'name', 'orgPlan', 'initialCredit', 'seats']
};
//# sourceMappingURL=orgInfo.js.map